import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'
import isEmpty from 'lodash/isEmpty'
import { Accordion } from 'discada/dist/Expando'

import { getDataOneSpecs } from 'selectors/inventorySelectors'

import './DetailedSpecs.scss'

export function DataOneSpecSection({ name, items }) {
  return (
    <div
      className={c('specs-section', 'data-one-specs', `specs-section-${name}`)}
    >
      <ul>
        {Object.keys(items).map(k => (
          <li key={k}>
            <span>{k}</span>
            <strong>{items[k]}</strong>
          </li>
        ))}
      </ul>
    </div>
  )
}

export function DetailedSpecs({ specs }) {
  if (isEmpty(specs)) return null

  return (
    <div className="vrp-section vehicle-detailed-specs">
      <Accordion items={Object.keys(specs)} header={({ item }) => item}>
        {({ item }) => (
          <DataOneSpecSection name={item} key={item} items={specs[item]} />
        )}
      </Accordion>
    </div>
  )
}

function mapStateToProps(state, op) {
  return { ...op, specs: getDataOneSpecs(state, op.id) }
}

export default connect(mapStateToProps)(DetailedSpecs)
